import React from "react";
import PropTypes from "prop-types";
import {
  SUBSCRIPTION_PLANS_HREF,
  getNoPlansAvailableCopy,
  getSinglePurchaseUnavailableCopy,
} from "../../helpers/singlePurchaseNotice";

// Trello 596 APP MISC "27 OCT 2". Same card tokens as the checkout
// payment-method cards (white, 1px #d7d7d7 border = theme primary.border,
// 20px radius, 16px inset and bottom gap), sized to its content: one line of
// copy and one link 8px below it. The link reuses the checkout's existing
// T&C link look (#00a551, underline, 500). Inline styles on purpose: this
// renders inside the checkout page and two landings with different style
// hooks, so it carries its own few tokens instead of a third makeStyles sheet.
const STYLES = {
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
    boxSizing: "border-box",
    padding: 16,
    marginBottom: 16,
    borderRadius: 20,
    border: "1px solid #d7d7d7",
    background: "#fff",
    textAlign: "left",
  },
  message: {
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 500,
    color: "#575757",
  },
  link: {
    marginTop: 8,
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 500,
    color: "#00a551",
    textDecoration: "underline",
  },
};

// The sentence and the link label always come from the same static copy for
// `language`, so they can never end up in two languages. `variant`
// "one-time" names the one-time switch-off; "no-plans" is the neutral line
// for a plan list that is empty for any other reason. `showLink` is false
// inside the app, which has its own plans screen.
const SubscriptionPlansNotice = ({ language, variant, showLink }) => {
  const copy = variant === "no-plans"
    ? getNoPlansAvailableCopy(language)
    : getSinglePurchaseUnavailableCopy(language);
  return (
    <div style={STYLES.root} data-testid="subscription-plans-notice" role="status">
      <span style={STYLES.message}>{copy.message}</span>
      {showLink && (
        <a href={SUBSCRIPTION_PLANS_HREF} style={STYLES.link}>
          {copy.linkLabel}
        </a>
      )}
    </div>
  );
};

SubscriptionPlansNotice.propTypes = {
  language: PropTypes.string,
  variant: PropTypes.oneOf(["one-time", "no-plans"]),
  showLink: PropTypes.bool,
};

SubscriptionPlansNotice.defaultProps = {
  language: "en",
  variant: "one-time",
  showLink: true,
};

export default SubscriptionPlansNotice;
